import React from "react";
import SwitchStep from "./SwitchStep";

const Template = (props) => {
   return <SwitchStep {...props} />;
};

export default Template;
